// extracted by mini-css-extract-plugin
export default {"productGallery":"tH-z","inQuickShop":"uH-z"};